<template>
  <div class="w-36">
    <MultiSelect
      :value="selectedValue"
      :options="years"
      :searchable="true"
      :can-clear="false"
      :can-deselect="false"
      :disabled="years.length <= 1"
      no-options-text="Geen jaren beschikbaar"
      no-results-text="Geen jaar gevonden"
      @input="onChange"
    />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import MultiSelect from '@/components/shared/MultiSelect.vue'

export default {
  name: 'DropDownYear',
  components: { MultiSelect },
  computed: {
    ...mapState(['selectedYear', 'selectedWoco', 'user']),
    years() {
      if (this.selectedWoco === null || this.selectedWoco === undefined) {
        return []
      }
      const woco = this.user.wocos.find((w) => w.name === this.selectedWoco)

      if (woco === undefined) {
        return []
      }

      return Object.keys(woco.available_years)
    },
    // A native <select> falls back to its first option when the bound value is
    // not in the list; mirror that so the select never renders blank.
    selectedValue() {
      return this.years.includes(this.selectedYear) ? this.selectedYear : this.years[0]
    },
  },
  methods: {
    ...mapMutations(['setSelectedYear']),
    onChange(value) {
      this.setSelectedYear(value)
    },
  },
  mounted() {
    if (this.years.length === 1) {
      this.setSelectedYear(this.years[0])
    }
  },
}
</script>
